import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { custom } from 'devextreme/ui/dialog';
import { OAuthService } from 'angular-oauth2-oidc';

import { BeforeSendEvent } from 'devextreme/ui/file_uploader';
import { DxFileUploaderTypes } from 'devextreme-angular/ui/file-uploader';
import { ProductDataSource } from '../../../Model/dataProcess/productDataSource';
import { Brand } from '../../../Model/Dto/Brand/Brand';
import { DataSourcesService } from '../../../Services/DataProcess/datasources.service';
import { LoginService } from '../../../Services/login.service';
import { SystemService } from '../../../Services/system.service';
import { DxTagBoxTypes } from 'devextreme-angular/ui/tag-box';
import { Address } from '../../../Model/Catalog/Address';

@Component({
  selector: 'app-edit-datasource',
  templateUrl: './edit-datasource.component.html',
  styleUrls: ['./edit-datasource.component.css']
})
export class EditDatasourceComponent implements OnChanges {

  @Output() visibleChange = new EventEmitter<boolean>();

  private _visible = false;
  selectedAltNames: string[] = [];

  altNameOptions: string[] = [];

  @Input()
  get visible(): boolean { return this._visible; }
  set visible(v: boolean) {
    if (this._visible !== v) {
      this._visible = v;
      this.visibleChange.emit(v);
    }
  }

  @Input() editMode = false;
  private _dataSource!: ProductDataSource;

  @Input()
  set dataSource(value: ProductDataSource | null | undefined) {
    const ds = value ?? ({} as ProductDataSource);

    if (!ds.addressObj) {
      ds.addressObj = new Address();
    }
    if (!ds.importerAddress) {
      ds.importerAddress = new Address();
    }

    this.isEuCountry =
      this.EU_CODES.has(ds.countryCode);

    this._dataSource = ds;
  }

  get dataSource(): ProductDataSource {
    return this._dataSource;
  }
  @Input() relatedBrands: Brand[] = [];
  @Input() types: any[] = [];
  @Input() countryCodes: string[] = [];
  @Input() uploadHeaders: Record<string, string> | undefined;

  @Output() saved = new EventEmitter<ProductDataSource>();

  private readonly EU_CODES = new Set<string>([
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
    'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK',
    'SI', 'ES', 'SE'
  ]);

  isEuCountry = false;
  fullScreen = false;

  value: any;
  constructor(
    private dataSourcesService: DataSourcesService,
    public loginService: LoginService,
    private systemService: SystemService,
    private translate: TranslateService,
    private oAuthService: OAuthService
  ) {
    this.save = this.save.bind(this);
    this.onCountryChanged = this.onCountryChanged.bind(this);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataSource'] && this.dataSource) {
      const init = this.dataSource.alternativeNames ?? [];

      this.altNameOptions = [...init];

      this.selectedAltNames = [...init];
    }
  }


  onCountryChanged(newCode: string): void {
    this.isEuCountry = this.EU_CODES.has(newCode);
  }

  toggleFullScreen = () => {
    this.fullScreen = !this.fullScreen;
  };

  addAlternativeName(e: any): void {
    const newName = (e.text ?? '').trim();
    if (!newName) {
      e.customItem = null;
      return;
    }

    if (!this.altNameOptions.includes(newName)) {
      this.altNameOptions = [...this.altNameOptions, newName];
    }
    e.customItem = newName;
  }

  onAltNamesChanged(e: DxTagBoxTypes.ValueChangedEvent) {
    this.selectedAltNames = e.value;
  }

  onBeforeSendUpload(event: BeforeSendEvent): void {
    event.request.withCredentials = true;
    event.request.setRequestHeader(
      'Authorization',
      'Bearer ' + this.oAuthService.getAccessToken()
    );
  }
  onUploaded(e: DxFileUploaderTypes.UploadedEvent): void {
    this.dataSource.logoFile = e.request.responseText as string;
  }

  async save(): Promise<void> {
    this.dataSource.alternativeNames = [...this.selectedAltNames];

    this.dataSource.lastUpdate = new Date();

    const result = await this.dataSourcesService.update(
      this.dataSource,
      this.loginService.currentCustomer.id
    );

    this.systemService.notifyInfo(
      this.translate.instant(
        this.editMode
          ? 'Lieferant wurde geändert'
          : 'Lieferant wurde angelegt'
      )
    );
    this.saved.emit(result);
    this.visibleChange.emit(false);
  }
}
